import React, { useState } from 'react'
import { Container, Row, Col, Accordion } from 'react-bootstrap'
import "./Faq.css"

const Faq = () => {
    return (
        <section className='faq_section section_margin'>
            <Container>
                <div className='section'>
                    <Row>
                        <Col  xl={3} md={5} sm={6}>
                            <div className='image_section'>
                                <div className='image'>
                                    <img src='./assets/images/home/FAQ/FAQ.png' alt='FAQ' className='faq_img' />
                                </div>
                                <div className='image-text'>
                                    <h2 className='text'>I have a QUESTION?</h2>
                                </div>
                            </div>
                        </Col>

                        <Col xl={9} md={7} sm={6}>
                            <div className='accordion_section'>
                                <Accordion defaultActiveKey="0" className='faq_accordion'>

                                    <Accordion.Item eventKey='0'>
                                        <Accordion.Header>Q1: What services does your app offer?</Accordion.Header>
                                        <Accordion.Body>
                                            We provide mobile recharges, DTH recharges, FASTag top-ups, utility bill payments, and more—all in one convenient platform.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey='1'>
                                        <Accordion.Header>Q2: How quickly will my recharge or payment be processed?</Accordion.Header>
                                        <Accordion.Body>We provide mobile recharges, DTH recharges, FASTag top-ups, utility bill payments, and more—all in one convenient platform.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey='2'>
                                        <Accordion.Header>Q3: Can I use the app on both mobile and web?</Accordion.Header>
                                        <Accordion.Body>
                                            We provide mobile recharges, DTH recharges, FASTag top-ups, utility bill payments, and more—all in one convenient platform.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey='3'>
                                        <Accordion.Header>Q4: Are there any additional charges or fees?</Accordion.Header>
                                        <Accordion.Body>
                                            We provide mobile recharges, DTH recharges, FASTag top-ups, utility bill payments, and more—all in one convenient platform.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey='4'>
                                        <Accordion.Header>Q5: Are there any rewards or offers for using the app?</Accordion.Header>
                                        <Accordion.Body>
                                            We provide mobile recharges, DTH recharges, FASTag top-ups, utility bill payments, and more—all in one convenient platform.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}

export default Faq